// components/Store/index.jsx
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { Tabs, Tab, Box, Typography, useTheme, useMediaQuery } from '@mui/material';

const StoreMain = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // ✅ 현재 경로에 따라 탭 인덱스 계산 (미니룸 제거)
    const pathname = location.pathname;
    const currentTab = pathname.includes('/emoticons') ? 1 : 0;

    const handleTabChange = (_, newValue) => {
        if (newValue === 0) navigate('/main/store');               // 쿠폰 상점
        if (newValue === 1) navigate('/main/store/emoticons');     // 이모티콘 상점
    };

    return (
        <Box sx={{ p: isMobile ? 1.5 : 3 }}>
            <Typography
                variant="h5"
                gutterBottom
                sx={{ fontSize: isMobile ? '1.3rem' : undefined, fontWeight: 600 }}
            >
                🛒 아이템 상점
            </Typography>

            <Tabs
                value={currentTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                sx={{ mb: isMobile ? 1.5 : 2 }}
                variant={isMobile ? 'fullWidth' : 'standard'}
            >
                <Tab label="🎫 쿠폰 상점" sx={{ minWidth: isMobile ? 80 : undefined, fontSize: isMobile ? '0.85rem' : undefined }} />
                <Tab label="😊 이모티콘 상점" sx={{ minWidth: isMobile ? 80 : undefined, fontSize: isMobile ? '0.85rem' : undefined }} />
            </Tabs>

            <Outlet />
        </Box>
    );
};

export default StoreMain;
